import React, { useState } from "react";
import axios from "axios";


const useConfirmTuitionFeeStudentDetail = ({
    onFinish = ({ axiosMode, status, values }) => { }, //
    onBefore = ({ axiosMode, status }) => { }, //
}) => {
    const mainApi = `/cramSchool/api/bill_payment_grade_class_student`
    const [data, setData] = useState([])
    const getConfirmTuitionFeeStudentDetailData = ({
        cur_page,
        size,
        custom_filter_value,
        custom_filter_key,
        order,
        bill_payment_id
    }) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: {
                cur_page,
                size,
                custom_filter_value,
                custom_filter_key,
                order,
                bill_payment_id
            },
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }

    const postConfirmTuitionFeeStudentDetailData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                console.log({ responseData })
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    const patchConfirmTuitionFeeStudentDetailData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(`/cramSchool/api/bill_payment/student_installment`,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteConfirmTuitionFeeStudentDetailData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const getBillPaymentGradeClassStudentReceiptPdf = ({
        bill_payment_grade_class_student_id
    }) => {

        return axios.get(`/cramSchool/api/export_bill`, {
            params: {
                bill_payment_grade_class_student_id
            },
            responseType: 'blob'
        },
        )
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `收據.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    }

    const postBillPaymentGradeClassStudentNotification = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/cramSchool/api/bill_payment_grade_class_student/notification',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: {
                                mode: "notification"
                            }
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    
    return {
        confirmTuitionFeeStudentDetailDatas: data,
        getConfirmTuitionFeeStudentDetailData,
        postConfirmTuitionFeeStudentDetailData,
        patchConfirmTuitionFeeStudentDetailData,
        deleteConfirmTuitionFeeStudentDetailData,
        getBillPaymentGradeClassStudentReceiptPdf,
        postBillPaymentGradeClassStudentNotification,
    }
}
export { useConfirmTuitionFeeStudentDetail }
